import React from "react";
import {
    Card,
    CardBody,
    CardHeader,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    UncontrolledDropdown,
    Table,
} from "reactstrap";
import ReactApexChart from "react-apexcharts";

const StaffReportOverview = () => {

    // Biết được số giờ làm việc của từng nhân viên trong tháng
    const workingHours = [
        { label: 'Nguyễn Văn A', value: 208 },
        { label: 'Nguyễn Văn B', value: 192 },
        { label: 'Nguyễn Văn C', value: 176 },
        { label: 'Nguyễn Văn D', value: 160 },
    ];

    const series = [{
        name: 'Sessions',
        data: workingHours.map(item => item.value),
    }];

    const options: any = {
        chart: {
            type: 'bar',
            height: 436,
            toolbar: { show: false },
        },
        plotOptions: {
            bar: {
                borderRadius: 4,
                horizontal: true,
                distributed: false,  // Chỉ dùng một màu duy nhất
                dataLabels: {
                    position: 'top',
                },
            }
        },
        colors: ['#007bff'], // Sử dụng một màu duy nhất (có thể đổi nếu cần)
        dataLabels: {
            enabled: true,
            offsetX: 32,
            style: {
                fontSize: '12px',
                fontWeight: 400,
                colors: ['#adb5bd']
            }
        },
        legend: { show: false },
        grid: { show: false },
        xaxis: {
            categories: workingHours.map(item => item.label),
        },
    };

    return (
        <React.Fragment>
            <div className="page-content-wrapper py-3">
                <div className="container">
                    <Card>
                        <CardHeader>
                            <div className="d-flex">
                                <h5 className="card-title mb-0 flex-grow-1  ">Thời gian làm việc</h5>
                                <div className="flex-shrink-0">
                                    <UncontrolledDropdown className="card-header-dropdown">
                                        <DropdownToggle
                                            className="text-reset dropdown-btn"
                                            tag="a"
                                            type="a"
                                            to="#"
                                        >
                                            <span className="fw-semibold text-uppercase fs-12">
                                              Lọc theo:{" "}
                                            </span>
                                            <span className="text-muted">
                                          Tuần này
                                          <i className="mdi mdi-chevron-down ms-1"></i>
                                        </span>
                                        </DropdownToggle>
                                        <DropdownMenu className="dropdown-menu-end">
                                            <DropdownItem href="#">Tháng này</DropdownItem>
                                            <DropdownItem href="#">Tháng trước</DropdownItem>
                                        </DropdownMenu>
                                    </UncontrolledDropdown>
                                </div>
                            </div>
                        </CardHeader>
                        <CardBody>
                            <ReactApexChart dir="ltr"
                                options={options}
                                series={series}
                                type="bar"
                                height="436"
                                className="apex-charts"
                            />
                        </CardBody>
                    </Card>
                    <Card className={"mt-2"}>
                        <CardHeader>
                            <div className="d-flex">
                                <h5 className="card-title mb-0 flex-grow-1">Báo cáo chi tiết</h5>
                                <div className="flex-shrink-0">
                                    <UncontrolledDropdown className="card-header-dropdown">
                                        <DropdownToggle
                                            className="text-reset dropdown-btn"
                                            tag="a"
                                            type="a"
                                            to="#"
                                        >
                                            <span className="fw-semibold text-uppercase fs-12">
                                              Lọc theo:{" "}
                                            </span>
                                            <span className="text-muted">
                                          Tuần này
                                          <i className="mdi mdi-chevron-down ms-1"></i>
                                        </span>
                                        </DropdownToggle>
                                        <DropdownMenu className="dropdown-menu-end">
                                            <DropdownItem href="#">Tất cả</DropdownItem>
                                            <DropdownItem href="#">Nguyễn Văn A</DropdownItem>
                                            <DropdownItem href="#">Nguyễn Văn B</DropdownItem>
                                            <DropdownItem href="#">Nguyễn Văn C</DropdownItem>
                                            <DropdownItem href="#">Nguyễn Văn D</DropdownItem>
                                        </DropdownMenu>
                                    </UncontrolledDropdown>
                                </div>
                            </div>
                        </CardHeader>
                        <CardBody>
                            <Table className="align-middle table-nowrap mb-0">
                                <thead>
                                <tr>
                                    <th scope="col">Ngày</th>
                                    <th scope="col">Nhân viên</th>
                                    <th scope="col">Giờ vào</th>
                                    <th scope="col">Giờ ra</th>
                                    <th scope="col">Tổng giờ</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td>15/02/2025</td>
                                    <td>Nguyễn Văn A</td>
                                    <td>08:00</td>
                                    <td>17:00</td>
                                    <td>8</td>
                                </tr>
                                <tr>
                                    <td>15/02/2025</td>
                                    <td>Nguyễn Văn B</td>
                                    <td>08:00</td>
                                    <td>17:00</td>
                                    <td>8</td>
                                </tr>
                                <tr>
                                    <td>15/02/2025</td>
                                    <td>Nguyễn Văn C</td>
                                    <td>08:00</td>
                                    <td>17:00</td>
                                    <td>8</td>
                                </tr>
                                <tr>
                                    <td>15/02/2025</td>
                                    <td>Nguyễn Văn D</td>
                                    <td>08:00</td>
                                    <td>17:00</td>
                                    <td>8</td>
                                </tr>
                                </tbody>
                            </Table>
                        </CardBody>
                    </Card>
                </div>
            </div>
        </React.Fragment>
    );
};

export default StaffReportOverview;
